exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".roleTag-62d48{margin-bottom:.3rem}.permissionCell-4f5fa{white-space:normal}", ""]);

// Exports
exports.locals = {
	"roleTag": "roleTag-62d48",
	"permissionCell": "permissionCell-4f5fa"
};